import { NgClass } from '@angular/common';
import { ChangeDetectorRef, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { ProgressSpinner } from 'primeng/progressspinner';
import { Subscription } from 'rxjs';
import { takeWhile } from 'rxjs/operators';

import { ProgressIndicatorService } from '../../services/progress-indicator.service';

@Component({
  selector: 'app-progress-indicator',
  templateUrl: './progress-indicator.component.html',
  styleUrls: ['./progress-indicator.component.scss'],
  imports: [NgClass, ProgressSpinner],
})
export class ProgressIndicatorComponent implements OnDestroy, OnInit {
  private indicatorService = inject(ProgressIndicatorService);
  private cd = inject(ChangeDetectorRef);

  activeSubscription = true;
  subscription: Subscription;

  public visible = true;
  public message = '';
  ngOnInit(): void {
    this.createProgressSubscription();
  }

  ngOnDestroy() {
    this.activeSubscription = false;
    this.subscription.unsubscribe();
  }

  createProgressSubscription() {
    this.subscription = this.indicatorService
      .getMessage()
      .pipe(takeWhile(() => this.activeSubscription))
      .subscribe((indicator) => {
        if (indicator) {
          this.message = indicator.message;

          if (indicator.show) {
            this.visible = true;
          } else {
            this.visible = false;
          }
        } else {
          this.message = null;
          this.visible = false;
        }
        this.cd.detectChanges();
      });
  }
}
